import { CircleSolidInfoIcon } from 'assets/icons';
import { Button, Dropdown } from 'components';
import { useTranslation } from 'react-i18next';
import { AccountViewType, SubjectOptionKeys } from 'views/Accounts/types';
import { NavigationPath } from 'types/DomainTypes';
import { useNavigate } from 'react-router-dom';
import { UseFeeModelInfoType } from '../hooks/useFeeModelInfo';

interface SelectPortfolioViewType {
  feeModelInfo: UseFeeModelInfoType;
  onClick: () => void;
}

const SelectPortfolioView = ({ feeModelInfo, onClick }: SelectPortfolioViewType) => {
  const { t } = useTranslation();
  const nav = useNavigate();

  return (
    <div className="flex flex-col bg-white dark:bg-slate-900 h-full p-4">
      <div className="flex flex-1 flex-col">
        {feeModelInfo.showFeeModelInfo && (
          <div className="mb-6">
            {/* Info Card */}
            <div className="bg-gradient-to-br from-gray-50 to-gray-100/80 dark:from-slate-800 dark:to-slate-800/50 rounded-xl p-4 border border-gray-100 dark:border-slate-700/50 shadow-sm dark:shadow-slate-950/30">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-sm font-semibold text-gray-900 dark:text-white">
                  {t('account:slideout.topup.recurring_payment_info_title')}
                </span>
                <CircleSolidInfoIcon className="w-5 h-5 text-orange dark:text-teal-400 flex-shrink-0" />
              </div>
              <p className="text-sm text-gray-600 dark:text-slate-400 leading-relaxed">
                {t(`account:slideout.topup.current_fee_model_info`)}
              </p>
            </div>
          </div>
        )}
        {feeModelInfo.ddlOptions.length > 1 && (feeModelInfo.canExecTransaction || feeModelInfo.canTopUp) && (
          <div className="flex flex-col gap-4">
            <Dropdown
              placeholder={t('common:selectPortfolio')}
              value={feeModelInfo.selectedPortfolio?.text}
              containerClassName="w-full rounded-xl"
              itemsContainerClassName="max-h-[250px] min-h-10 overflow-y-auto bg-white dark:bg-slate-700 rounded-xl shadow-lg dark:shadow-slate-950/50 border border-gray-200 dark:border-slate-600"
              className="flex-1 text-sm text-gray-900 dark:text-white border-2 border-gray-200 dark:border-slate-600 h-12 px-4 rounded-xl justify-between items-center bg-white dark:bg-slate-800 hover:border-orange/50 dark:hover:border-teal-500/50 transition-colors"
              itemsWrapperClassName="w-full"
              items={feeModelInfo.ddlOptions}
              onItemSelect={(item) => {
                feeModelInfo.setSelectedPortfolio(item);
              }}
            />
            <Button
              isDisable={!feeModelInfo.selectedPortfolio}
              className="w-full h-12 text-base font-semibold rounded-full btn bg-gradient-to-r from-orange to-orange/90 dark:from-teal-500 dark:to-teal-600 text-white shadow-lg shadow-orange/30 dark:shadow-teal-500/30 hover:shadow-xl hover:shadow-orange/40 dark:hover:shadow-teal-500/40 disabled:opacity-50 disabled:shadow-none transition-all flex justify-center items-center"
              onClick={onClick}
              props={{
                name: 'requestTab',
              }}
            >
              {feeModelInfo.getRemaingBalAndBtnText(true).btnText}
            </Button>
          </div>
        )}

        {!feeModelInfo.canTopUp && !feeModelInfo.canExecTransaction && (
          <Button
            className="w-full h-12 text-base font-semibold rounded-full btn bg-gradient-to-r from-orange to-orange/90 dark:from-teal-500 dark:to-teal-600 text-white shadow-lg shadow-orange/30 dark:shadow-teal-500/30 hover:shadow-xl hover:shadow-orange/40 dark:hover:shadow-teal-500/40 transition-all flex justify-center items-center"
            onClick={() => {
              nav(NavigationPath.ACCOUNTS, {
                state: {
                  accountViewType: AccountViewType.CONTACT_US,
                  subject: SubjectOptionKeys.FINANCIAL,
                },
              });
            }}
            props={{
              name: 'requestTab',
            }}
          >
            {t('common:contact')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default SelectPortfolioView;
